import Header from '../../components/global/Header';
import { Paper, Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Colors from '../../Constant/Colors';
import Logo from '../../assets/Images/DefaultAvatar.jpg';
import client from '../../API/client';
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const PendingReq = () => {
  const [request, setRequest] = useState([]);

  const approvePendingReq = async (recruiter_id) => {
    console.log(recruiter_id);
    await client
      .post(`/admin/approving-recruiter-pending-requests/${recruiter_id}`)
      .then((res) => {
        if (res.status === 200) {
          toast.success('Recruiter approved Sucessfully', {
            position: toast.POSITION.TOP_CENTER,
          });
          getPendingRequest();
        } else {
          toast.error('OOps!! Something went wrong ', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  };

  const getPendingRequest = async () => {
    await client
      .get('/admin/recruiter-pending-requests')
      .then((res) => {
        setRequest(res.data);
        // console.log("Pending Request",res)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const deletePendingReq = async (recruiter_id) => {
    console.log(recruiter_id);
    await client
      .post(`/admin/delete-recruiter-pending-requests/${recruiter_id}`)
      .then((res) => {
        if (res.status === 200) {
          toast.success('Request Deleted Sucessfully', {
            position: toast.POSITION.TOP_CENTER,
          });
          getPendingRequest();
        } else {
          toast.error('OOps!! Something went wrong ', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      });
  };
  useEffect(() => {
    getPendingRequest();
  }, []);

  return (
    <>
      <Box m="20px">
        <Header
          title="Recruiter Pending Request"
          subtitle="Approve the legitimate recruiter"
        />
        <ToastContainer/>
        <Paper
          elevation={5}
          style={{
            marginTop: '10px',
            padding: '20px',
            height: '680px',
            overflow: 'scroll',
            backgroundColor: 'whitesmoke',
          }}>
          {request.map((data, index) => (
            <Accordion key={index} sx={{ mb: '10px' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Box>
                  <Box
                    sx={{
                      flexDirection: 'row',
                      padding: '10px',
                      display: 'flex',
                      gap: '20px',
                    }}>
                    <img
                      alt="company logo"
                      src={Logo}
                      style={{
                        width: 70,
                        height: 70,
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                    <div
                      style={{
                        flexDirection: 'column',
                        display: 'flex',
                        alignSelf: 'center',
                      }}>
                      <span style={{ fontSize: '25px', color: Colors.primary }}>
                        {data.r_fullname}
                      </span>
                      <span style={{ fontSize: '18px', color: 'grey' }}>
                        company_name :-{' '}
                        <span style={{ color: Colors.darkblue }}>
                          {data.company_name}
                        </span>
                      </span>
                    </div>
                  </Box>
                </Box>
              </AccordionSummary>

              <AccordionDetails sx={{ mb: '10px' }}>
                <Box sx={{ padding: '10px' }}>
                  <div style={{ marginBottom: '10px' }}>
                    <h3>Details</h3>
                  </div>
                  <Box mb="10px">
                    <span>Username :- {data.r_username}</span>
                  </Box>
                  <Box mb="10px">
                    <span>Email :- {data.r_email}</span>
                  </Box>
                  <Box mb="10px">
                    <span>Company Location :- {data.company_loc}</span>
                  </Box>
                  <Button
                    sx={{ width: '15%', letterSpacing: 1, marginTop: '10px' }}
                    variant="contained"
                    onClick={() => approvePendingReq(data.recruiter_id)}>
                    Approve
                  </Button>
                  <Button
                    onClick={() => deletePendingReq(data.recruiter_id)}
                    sx={{
                      letterSpacing: 1,
                      marginTop: '10px',
                      marginLeft: '10px',
                      borderColor: 'red',
                    }}
                    variant="outlined">
                    <DeleteIcon color="error" />
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Box>
    </>
  );
};
